import React from 'react';
import ReactMarkdown from 'react-markdown';
import { graphql, Link } from "gatsby";
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '../../components/Layout';
import Button from '../../components/Button';

import ChevronDown from '../../images/chevron-down.svg';
import ChevronRight from '../../images/chevron-right.svg';

const Scheme = ({data}) => {
  const scheme = data.strapiScheme;

  let locations = scheme.Locations.map((location, i) => {
    if (scheme.Locations.length === (i + 1)) {
      return location.Name;
    }
    return `${location.Name}, `;
  });
  if (locations.length === 0) locations = 'Essex-wide';

  const applicationStateObj = {
    persona: scheme.Personas.length > 0 ? scheme.Personas[0].Slug : 'different-persona',
    location: scheme.Locations.length > 0 ? scheme.Locations[0].Slug : 'essex-wide',
    schemes: scheme.Slug,
  };

  return (
    <Layout title={scheme.Title}>
      <div className="pt-8 bg-white">
        <div className="container mx-auto px-12">
          <Link to="/schemes" className="font-bold">
            <img className="inline mr-2 transform rotate-90" src={ChevronDown} alt="" />
            Back to Schemes
          </Link>
          <h1 className="text-2xl font-semibold mt-4 mb-6">{scheme.Title}</h1>
          <div className="text-orange text-md font-semibold">
            <StaticImage src="../../images/location-icon.svg" alt="" loading="eager" placeholder="tracedSVG" className="mr-4" />
            {locations}
          </div>
          <div className="my-8">
            <h3 className="text-md font-bold mt-8 mb-4">About the sheme</h3>
            <div className="prose max-w-5xl">
              <ReactMarkdown children={scheme.About} />
            </div>
            <h3 className="text-md font-bold mt-8 mb-4">Am I eligible?</h3>
            <div className="prose max-w-5xl">
              <ReactMarkdown children={scheme.Eligibility} />
            </div>
          </div>
        </div>
        <div className="py-12 bg-gradient-to-br from-orange-medium to-orange-dark text-white">
          <div className="container mx-auto px-12">
            <div>
              <h3 className="text-md font-bold mb-4">How to Apply</h3>
              <p className="">You can apply by via the methods below or you can submit an application online using our form.</p>
              <div className="max-w-xs mt-6">
                <Button
                  className="border-orange-darkest border-2 !bg-orange-dark hover:border-white shadow-md"
                  primary="true"
                  state={applicationStateObj}
                  tag={Link}
                  to="/what-schemes-are-available-for-me/schemes"
                >
                  Start application
                  <img className="inline ml-2 -mt-px" src={ChevronRight} alt="" />
                </Button>
              </div>
            </div>
            {
              scheme.CallToAction && (
                <div className="mt-8">
                  <h3 className="text-md font-bold mb-4">Contact</h3>
                  <div className="prose prose-scheme-contact max-w-none">
                    <ReactMarkdown children={scheme.CallToAction} />
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
    </Layout>
  );
}

export const query = graphql`
  query SchemeQuery($Slug: String) {
    strapiScheme(Slug: {eq: $Slug}) {
      Slug
      Title
      Personas {
        Slug
      }
      Locations {
        Slug
        Name
      }
      Image {
        localFile {
          childImageSharp {
            gatsbyImageData
          }
        }
        alternativeText
      }
      About
      Eligibility
      CallToAction
    }
  }
`;

export default Scheme;